import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./Intro.css";
import stressscale from "../../../img/test-images/intro-images/stress-intro.svg";
import clock from "../../../img/test-images/clock.svg";

function Intro() {
  return (
    <div className="intro-div">
      <Container className="intro-container">
        <Row>
          <Col md={6}>
            <img src={stressscale} alt="stress-scale" />
          </Col>
          <Col md={6}>
            <p>
              Stress is a response by our brain based on how we assess or view a
              situation. We've all experienced stress sometime in our life.
              Sometimes, stress can actually be helpful and increase your
              performance. But a lot of times it actually does more harm than
              good. This test can help you understand in which aspect of life
              are you currently stressed about and how helpful or unhelpful that
              stress is for you.
            </p>
            <p>
              Click the button below and read the instructions at the next page
              carefully.
            </p>
            <div className="test-time">
              <img src={clock} alt="time" />5 - 9 minutes
            </div>
            <Button
              variant="secondary"
              size="lg"
              href="/selfevaluation/stress-scale/instructions"
            >
              Proceed
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Intro;
